export default "__VITE_ASSET__9fIbVueT__"